import { OnInit, Component, HostListener } from '@angular/core';
import { QuestionService, WindowService } from 'src/app/service/api';

@Component({
  templateUrl: 'support.component.html',
  styleUrls: ['support.component.scss'],
})
export class SupportComponent implements OnInit {
  supportList = [];
  filterSupportList = [];
  showHint = false;
  viewHeight = window.innerHeight;
  private _window: WindowService;

  constructor(
    protected questionService: QuestionService, 
    private windowService: WindowService
  ) {
    this._window = this.windowService;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (document.documentElement.scrollTop == 0) {
      this.showHint = false;
    }
    if (document.documentElement.scrollTop >= this.viewHeight / 2) {
      this.showHint = true;
    }
  }

  ngOnInit(): void {
    this.initSupportList();
  }

  initSupportList(): void {
    this.questionService.getQuestions().subscribe(
      (questions: any[]) => {
        this.supportList = questions;
        this.filterSupportList = questions;
      },
      (err) => console.error(err)
    );
  }

  handleSearch(query) {
    this.filterSupportList = this.supportList.filter(
      (item) =>
        item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        item.content.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  openSupportLink() {
    this._window.open('https://mobilerndhub.sec.samsung.net/its/projects/SARB', '_blank');
  }
}
